"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import type { PromoModal } from "@/lib/promoModal/types";
import { PagePromoModal } from "./PagePromoModal";
interface Props {
  modals: PromoModal[];
  isPreview: boolean;
}

/** Remounts per pathname, so each page gets a fresh one-popup allowance. */
export function EmailPromoModalSelector(t0) {
  const $ = _c(4);
  const {
    modals,
    isPreview
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== isPreview || $[1] !== modals || $[2] !== pathname) {
    t1 = <PagePromoModal key={pathname} modals={modals} pathname={pathname} isPreview={isPreview} />;
    $[0] = isPreview;
    $[1] = modals;
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}